import glamorous from 'glamorous';

export const TextAreaWrapper = glamorous.textarea('ncss-textarea p4-sm', () => ({
  color: '#031B39',
  resize: 'none !important',
}));
TextAreaWrapper.displayName = 'TextAreaWrapper';

export const SectionWrapper = glamorous.div(() => ({
  '> p': {
    textAlign: 'right',
    color: '#031B39',
    fontSize: '10px',
    padding: 0,
  },
}));
SectionWrapper.displayName = 'SectionWrapper';




// WEBPACK FOOTER //
// ./src/components/TextArea/TextArea.style.js